import { StyledStat, StatCopy, StatHeadline } from './styles';
import type { IStat } from './types';

const Stat = ({
  background = 'light', headline, subcopy, ...rest
}: IStat) => (
  <StyledStat $background={background} key={JSON.stringify(headline + subcopy)} {...rest}>
    <StatHeadline $background={background} content={headline} styledAs="display3" tag="div" />
    <StatCopy $background={background} content={subcopy} styledAs="h5" tag="div" />
  </StyledStat>
);

export default Stat;
